import { Card, CardContent } from '@/components/ui/Card';

export const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">About Custom AI Solutions</h1>
          <p className="text-xl text-gray-600">
            Making custom software accessible to everyone
          </p>
        </div>

        <Card className="mb-8">
          <CardContent className="pt-6 space-y-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
              <p className="text-gray-700 leading-relaxed">
                We believe every business deserves custom software that fits their unique needs — without
                the complexity, confusion, or excessive costs typically associated with software development.
                Custom AI Solutions bridges the gap between what you need and what's technically possible.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">How We're Different</h2>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">✓</span>
                  <span>
                    <strong>Simple Process:</strong> Answer 8 questions, get a quote, approve, and watch it build
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">✓</span>
                  <span>
                    <strong>Transparent Pricing:</strong> No hidden fees, clear quotes, and honest timelines
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">✓</span>
                  <span>
                    <strong>AI-Assisted Development:</strong> We leverage AI to accelerate development without sacrificing quality
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">✓</span>
                  <span>
                    <strong>Full Ownership:</strong> You own your code, data, and domain — no lock-in
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">✓</span>
                  <span>
                    <strong>Ongoing Support:</strong> We're here to help with updates, changes, and support after launch
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Tech Stack</h2>
              <p className="text-gray-700 mb-4">
                We build with modern, battle-tested technologies to ensure your software is fast,
                reliable, and scalable:
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {[
                  'React & TypeScript',
                  'Node.js & Express',
                  'PostgreSQL',
                  'Tailwind CSS',
                  'AI/ML Integration',
                  'Cloud Hosting',
                  'Mobile-First Design',
                  'RESTful APIs',
                  'Real-time Features',
                ].map((tech) => (
                  <div key={tech} className="bg-blue-50 text-blue-900 px-4 py-2 rounded text-sm font-medium text-center">
                    {tech}
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">What We Build</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">Business Tools</h3>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• CRM systems</li>
                    <li>• Booking platforms</li>
                    <li>• Inventory management</li>
                    <li>• Invoicing & payments</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">Web Applications</h3>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Dashboards & portals</li>
                    <li>• E-commerce stores</li>
                    <li>• Social platforms</li>
                    <li>• Content management</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">AI-Powered Apps</h3>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Chatbots & assistants</li>
                    <li>• Recommendation engines</li>
                    <li>• Data analysis tools</li>
                    <li>• Automation workflows</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">Integrations</h3>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Payment gateways</li>
                    <li>• Email & SMS</li>
                    <li>• Third-party APIs</li>
                    <li>• Legacy system connectors</li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Based in South Africa</h2>
              <p className="text-gray-700 leading-relaxed">
                We're a South African company building software for local and international clients.
                All pricing is in South African Rand (ZAR), and we understand the unique needs and
                constraints of businesses operating in emerging markets.
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="text-center">
          <a
            href="/wizard"
            className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Start Your Project
          </a>
        </div>
      </div>
    </div>
  );
};
